import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  detail: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ])
}

const ProductDetailView = ({ detail }) => {
  const isObject  = typeof detail === 'object'
  const isString  = typeof detail === 'string'
  const isBoolean = typeof detail === 'boolean'

  return (
    <>
      { isObject && JSON.stringify(detail) }
      { isString && !detail && 'none' }
      { isString && detail }
      { isBoolean && `${detail}` }
    </>
  )
}

ProductDetailView.propTypes = propTypes

export default ProductDetailView
